<template>
    <hts-card>
        <h3>
            Cài đặt nhắc nhở hết hạn cho:
        </h3>

        <hts-form @submit="handleSubmit">
            <hts-form-checkbox
                v-model="formData.reminders"
                label=""
                value-key="value"
                :items="listRadioFragileTypes" />

            <div
                v-if="formData.reminders.includes('insurance') && formData.reminderDetail.insurance"
                class="mt-5">
                <h3>
                    Bảo hiểm
                </h3>

                <div class="sm:flex gap-10 items-end">
                    <hts-form-input
                        v-model="formData.reminderDetail.insurance.reminderAdvance"
                        label="Nhắc nhở trước"
                        required
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>

                    <hts-form-input
                        v-model="formData.reminderDetail.insurance.repeat"
                        label="Nhắc nhở lại sau"
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>
                </div>
            </div>

            <div
                v-if="formData.reminders.includes('registry') && formData.reminderDetail.registry"
                class="mt-5">
                <h3>
                    Đăng kiểm
                </h3>

                <div class="sm:flex gap-10 items-center">
                    <hts-form-input
                        v-model="formData.reminderDetail.registry.reminderAdvance"
                        label="Nhắc nhở trước"
                        required
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>

                    <hts-form-input
                        v-model="formData.reminderDetail.registry.repeat"
                        label="Nhắc nhở lại sau"
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>
                </div>
            </div>

            <hts-form-button
                class="mt-20"
                icon-position="right"
                color="primary"
                type="submit">
                {{ $t('labels.save') }}
            </hts-form-button>
        </hts-form>
    </hts-card>
</template>
<script setup lang="ts">
const store = $store()

const formData = ref({
  reminders: [] as string[],
  reminderDetail: {
    insurance: {
      reminderAdvance: 30,
      repeat: null
    },
    registry: {
      reminderAdvance: 30,
      repeat: null
    }
  } as { [key: string]: any }
})

onMounted(() => {
  const globalSettingsInformation = store.globalSettings.getGlobalSettings

  const reminders = globalSettingsInformation.partner.remooc.reminders

  formData.value.reminders = reminders

  reminders.forEach((item: string) => {
    formData.value.reminderDetail[item] = globalSettingsInformation.partner.remooc.reminderDetail[item]
  })
})

const listRadioFragileTypes = [
  { value: 'insurance', label: $t('labels.insurance') },
  { value: 'registry', label: $t('labels.registry') }
]

const submitForm = () => {
  const api = $urlClient.settings.updatePartnerSettings
  const data = {
    type: 'remooc',
    ...formData.value
  }
  $api(api, { body: { ...data } })
    .then((dataRes) => {
      if (!dataRes) {
        return true
      }
      process.client && $toast().success($t('notifications.updateSuccess'))
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}
const handleSubmit = $lodash.debounce(submitForm, 500)
</script>
